// Import Vue
// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
import arrastrable from './directives/arrastrable.js';
// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';
// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';
// Import VTooltip
import VTooltip from 'v-tooltip';
import Vue from 'vue';
/* VENDOR */
import VueI18n from 'vue-i18n';
import LoadScript from 'vue-plugin-load-script';
/******** */
import VueSignature from "vue-signature-pad";
import VueTheMask from 'vue-the-mask';
// Import App Component
import App from '../components/app.vue';
import rPage from '../components/rPage.vue';
import '../css/app.css';
import '../css/custom-icons.css';
// Import Icons and App Custom Styles
import '../css/icons.css';
import vuetify from '../plugins/vuetify';
import messages from './translations.js';
import Utils from "./Utils.js";
import UpdateManager from './UpdateManager.js';
import { instalarRecogidaDeCancelaciones } from './utils/sesionDePeticiones.js';
import VueFilterDateFormat from './vue-filter-date-format';
import VueFilterDateParse from './vue-filter-date-parse.js';
import VueFilterNumberFormat from './vue-filter-number-format.js';
import VueFilterTimeInHoursParse from './vue-filter-time-in-hours-parse.js';









// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);


Vue.use(VueI18n)
Vue.use(VueFilterDateFormat);
Vue.use(VueFilterDateParse)
Vue.use(VueFilterTimeInHoursParse)
Vue.use(VueFilterNumberFormat)
Vue.use(VueTheMask)
Vue.use(LoadScript);
Vue.component('r-page', rPage);

Vue.use(VTooltip);
var lang = localStorage.getItem("lang") || 'es';
const i18n = new VueI18n({
    locale: lang,
    messages,
});

Vue.use(VueSignature);

// Mixin global para añadir automáticamente la funcionalidad de popup enhancer
Vue.mixin({
    mounted() {
        // Buscar popups en este componente específico
        this.$nextTick(() => {
            this.enhanceComponentPopups();
        });
    },
    updated() {
        // Solo aplicar después de actualizaciones si es necesario
        this.$nextTick(() => {
            this.enhanceComponentPopups();
        });
    },
    methods: {
        enhanceComponentPopups() {
            // Validaciones mejoradas para this.$el
            if (!this.$el) {
                console.log('Component has no $el, skipping popup enhancement');
                return;
            }
            
            // Verificar que $el sea un elemento del DOM válido
            if (this.$el.nodeType !== 1) { // Node.ELEMENT_NODE
                console.log('Component $el is not an element node, skipping popup enhancement');
                return;
            }
            
            // Verificar que tenga el método querySelectorAll
            if (typeof this.$el.querySelectorAll !== 'function') {
                console.log('Component $el does not have querySelectorAll method, skipping popup enhancement');
                return;
            }
            
            try {
                // Buscar solo popups directos de este componente
                const popupElements = [
                    ...this.$el.querySelectorAll('.popup:not([data-popup-enhanced])'),
                    ...this.$el.querySelectorAll('f7-popup:not([data-popup-enhanced])'),
                    ...this.$el.querySelectorAll('[data-name="popup"]:not([data-popup-enhanced])')
                ];
                
                popupElements.forEach(popup => {
                    console.log('Component enhancing popup:', popup);
                    enhancePopup(popup, this);
                });
            } catch (error) {
                console.error('Error in enhanceComponentPopups:', error);
            }
        }
    },
    beforeDestroy() {
        // Limpiar observers específicos del componente si existen
        if (this._componentPopupObserver) {
            this._componentPopupObserver.disconnect();
        }
    }
});


Vue.directive('roles', {
    bind: function(el, binding, vnode) {
        // el.setAttribute("data-initial-display", el.style.display == null ? "" : el.style.display);
        checkPermission(el, binding.value.roles || binding.value, vnode);
    },
    update: function(el, binding, vnode) {
        checkPermission(el, binding.value.roles || binding.value, vnode);
    }
});
Vue.directive('noroles', {
    bind: function(el, binding, vnode) {
        // el.setAttribute("data-initial-display", el.style.display == null ? "" : el.style.display);
        checkNoPermission(el, binding.value, vnode);
    },
    update: function(el, binding, vnode) {
        checkNoPermission(el, binding.value, vnode);
    }
});
Vue.directive('focusableNextElement', {
    bind: function(el, binding, vnode) {
        if (typeof binding.value == 'undefined' || binding.value) {
            el.addEventListener('keyup', function(ev) {
                if (ev.key == 'Enter') {
                    ev.preventDefault();
                    Utils.focusNextElement(ev, el);
                }
            });
        }
    }
});

// Popups que se pueden mover arrastrando su barra (ver src/js/directives/arrastrable.js).
Vue.directive('arrastrable', arrastrable);

// Directiva para añadir funcionalidad de maximizar y redimensionar a los popups
Vue.directive('popup-enhancer', {
    bind: function(el, binding, vnode) {
        // Esperamos a que el componente esté montado
        Vue.nextTick(() => {
            enhancePopup(el, vnode);
        });
    },
    inserted: function(el, binding, vnode) {
        enhancePopup(el, vnode);
    }
});

// Función para validar que un popup sea válido antes de procesarlo
function isValidPopupElement(el) {
    if (!el) {
        return { valid: false, reason: 'Element is null/undefined' };
    }
    
    if (!el.parentNode) {
        return { valid: false, reason: 'Element has no parent node' };
    }
    
    if (!document.contains(el)) {
        return { valid: false, reason: 'Element is not in DOM' };
    }
    
    try {
        if (!el.classList) {
            return { valid: false, reason: 'Element has no classList' };
        }
        
        if (el.classList.contains('popup-closing')) {
            return { valid: false, reason: 'Popup is closing' };
        }
        
        if (el.style && el.style.display === 'none') {
            return { valid: false, reason: 'Popup is hidden' };
        }
        
        if (!el.classList.contains('popup') && el.tagName !== 'F7-POPUP') {
            return { valid: false, reason: 'Element is not a popup' };
        }
        
        if (el.dataset && el.dataset.popupEnhanced) {
            return { valid: false, reason: 'Popup already enhanced' };
        }
        
    } catch (error) {
        return { valid: false, reason: 'Error accessing element properties: ' + error.message };
    }
    
    return { valid: true, reason: 'Valid popup element' };
}

function enhancePopup(el, vnode) {
    // Validación usando la función helper
    const validation = isValidPopupElement(el);
    if (!validation.valid) {
        console.log('Skipping popup enhancement:', validation.reason, el);
        return;
    }
    
    console.log('Attempting to enhance popup:', el);
    
    // Marcar como enhanced para evitar procesamiento múltiple
    try {
        el.dataset.popupEnhanced = 'true';
    } catch (error) {
        console.error('Error setting popup enhanced flag:', error);
        return;
    }

    // Verificar si el popup ya es tablet-fullscreen - con validaciones
    let isTabletFullscreen = false;
    try {
        isTabletFullscreen = el.hasAttribute('tablet-fullscreen') || 
                            el.classList.contains('tablet-fullscreen') ||
                            (el.closest('f7-popup') && el.closest('f7-popup').hasAttribute('tablet-fullscreen'));
    } catch (error) {
        console.error('Error checking tablet-fullscreen status:', error);
        isTabletFullscreen = false;
    }
    
    if (isTabletFullscreen) {
        console.log('Popup is already tablet-fullscreen, skipping maximize button');
        try {
            // Solo aplicar estilos de redimensionar pero no el botón de maximizar
            el.style.resize = 'both';
            el.style.overflow = 'auto';
            el.style.minWidth = '200px';
            el.style.minHeight = '150px';
            el.style.maxWidth = '90vw';
            el.style.maxHeight = '90vh';
            el.style.position = 'fixed';
            el.style.top = '50%';
            el.style.left = '50%';
            el.style.transform = 'translate(-50%, -50%)';
            el.style.margin = '0';
        } catch (error) {
            console.error('Error applying tablet-fullscreen styles:', error);
        }
        return;
    }

    console.log('Enhancing popup...');

    // Función para buscar o crear navbar
    function findOrCreateNavbar() {
        // Buscar navbar existente con diferentes selectores
        let navbar = el.querySelector('.navbar') || 
                    el.querySelector('f7-navbar') || 
                    el.querySelector('.f7-navbar') ||
                    el.querySelector('[class*="navbar"]');

        console.log('Found navbar:', navbar);
        if (navbar) {
            console.log('Navbar classList:', navbar.classList ? Array.from(navbar.classList) : 'No classList');
            console.log('Navbar tagName:', navbar.tagName);
            console.log('Navbar innerHTML (first 200 chars):', navbar.innerHTML ? navbar.innerHTML.substring(0, 200) : 'No innerHTML');
        }

        if (!navbar) {
            console.log('No navbar found, creating one...');
            // Crear un navbar básico si no existe
            navbar = document.createElement('div');
            navbar.className = 'navbar';
            
            const navbarInner = document.createElement('div');
            navbarInner.className = 'navbar-inner';
            
            const navTitle = document.createElement('div');
            navTitle.className = 'title';
            navTitle.textContent = 'Popup';
            
            navbarInner.appendChild(navTitle);
            navbar.appendChild(navbarInner);
            
            // Insertar al principio del popup
            const popupContent = el.querySelector('.popup-content') || 
                               el.querySelector('f7-page') || 
                               el.querySelector('.page') || 
                               el;
            popupContent.insertBefore(navbar, popupContent.firstChild);
        }

        return navbar;
    }

    const navbar = findOrCreateNavbar();
    if (!navbar) {
        console.error('Could not find or create navbar for popup');
        return;
    }

    console.log('Working with navbar:', navbar);
    console.log('Navbar structure before nav-right search:');
    console.log('- navbar.innerHTML:', navbar.innerHTML ? navbar.innerHTML.substring(0, 300) : 'No innerHTML');

    // Buscar nav-right o crearlo con detección mejorada para Framework7 Vue
    let navRight = navbar.querySelector('.nav-right') || 
                   navbar.querySelector('.right') ||
                   navbar.querySelector('f7-nav-right') ||
                   navbar.querySelector('.f7-nav-right');

    console.log('Initial navRight search result:', navRight);

    // Si es un f7-navbar (Framework7 Vue), buscar dentro de él
    if (!navRight && navbar.tagName === 'F7-NAVBAR') {
        console.log('Searching inside F7-NAVBAR for nav-right elements...');
        const shadowRoot = navbar.shadowRoot;
        if (shadowRoot) {
            navRight = shadowRoot.querySelector('.nav-right') || 
                      shadowRoot.querySelector('.right') ||
                      shadowRoot.querySelector('f7-nav-right');
            console.log('Found in shadowRoot:', navRight);
        }
        
        // También buscar en los slots si no se encuentra en shadowRoot
        if (!navRight) {
            navRight = navbar.querySelector('[slot="nav-right"]') ||
                      navbar.querySelector('[slot="right"]');
            console.log('Found in slots:', navRight);
        }
    }

    if (!navRight) {
        console.log('No nav-right found, creating one...');
        
        // Para f7-navbar, crear un elemento con slot
        if (navbar.tagName === 'F7-NAVBAR') {
            navRight = document.createElement('f7-nav-right');
            // Alternativamente, crear un div con slot
            // navRight = document.createElement('div');
            // navRight.setAttribute('slot', 'nav-right');
            console.log('Created f7-nav-right for F7-NAVBAR');
        } else {
            // Para navbar tradicional
            navRight = document.createElement('div');
            navRight.className = 'nav-right';
            console.log('Created traditional nav-right div');
        }
        
        // Buscar donde insertar el nav-right
        const navbarInner = navbar.querySelector('.navbar-inner') || navbar;
        navbarInner.appendChild(navRight);
        
        console.log('Appended nav-right to:', navbarInner);
    }

    console.log('Final nav-right element:', navRight);
    console.log('Nav-right parent:', navRight.parentElement);
    console.log('Nav-right classList:', navRight.classList ? Array.from(navRight.classList) : 'No classList');

    // Verificar si ya existe un botón de maximizar para evitar duplicación
    const existingMaximizeBtn = navRight.querySelector('.popup-maximize-btn');
    if (existingMaximizeBtn) {
        console.log('Maximize button already exists, skipping creation to prevent duplication');
        return;
    }

    // Crear botón de cerrar con icono
    const closeBtn = document.createElement('a');
    closeBtn.className = 'link popup-close-btn popup-close'; // Añadir popup-close como clase
    closeBtn.innerHTML = '<i class="f7-icons">xmark</i>';
    closeBtn.style.cursor = 'pointer';
    closeBtn.title = 'Cerrar';
    
    // Asegurar que el botón no interfiera con otros eventos del popup
    closeBtn.style.pointerEvents = 'auto';
    closeBtn.style.position = 'relative';
    closeBtn.style.zIndex = '1';
    closeBtn.style.display = 'inline-block';

    // Crear botón de maximizar/restaurar
    const maximizeBtn = document.createElement('a');
    maximizeBtn.className = 'link popup-maximize-btn';
    maximizeBtn.innerHTML = '<i class="f7-icons">arrow_up_left_arrow_down_right</i>';
    maximizeBtn.style.cursor = 'pointer';
    maximizeBtn.title = 'Maximizar/Restaurar';
    
    // Asegurar que el botón no interfiera con otros eventos del popup
    maximizeBtn.style.pointerEvents = 'auto';
    maximizeBtn.style.position = 'relative';
    maximizeBtn.style.zIndex = '1';
    maximizeBtn.style.display = 'inline-block';
    maximizeBtn.style.marginRight = '8px'; // Espacio entre botones

    console.log('Created close button:', closeBtn);
    console.log('Created maximize button:', maximizeBtn);

    // Estado del popup
    let isMaximized = false;
    let originalStyles = {};

    // Función para maximizar/restaurar
    const toggleMaximize = () => {
        console.log('Toggle maximize clicked, current state:', isMaximized);
        
        if (!isMaximized) {
            // Antes de guardar estilos, limpiar cualquier posicionamiento problemático del título
            const titleElement = navbar.querySelector('.title') || navbar.querySelector('f7-nav-title') || navbar.querySelector('.nav-title');
            if (titleElement) {
                console.log('Cleaning title positioning before maximize...');
                
                // Limpiar estilos problemáticos ANTES de maximizar
                if (titleElement.style.left && titleElement.style.left !== '' && titleElement.style.left !== 'auto') {
                    console.log('Cleaning problematic left from title before maximize:', titleElement.style.left);
                    titleElement.style.removeProperty('left');
                }
                
                if (titleElement.style.marginLeft && titleElement.style.marginLeft !== '' && titleElement.style.marginLeft !== 'auto') {
                    console.log('Cleaning problematic marginLeft from title before maximize:', titleElement.style.marginLeft);
                    titleElement.style.removeProperty('margin-left');
                }
                
                if (titleElement.style.transform && titleElement.style.transform.includes('translateX') && !titleElement.style.transform.includes('-50%')) {
                    console.log('Cleaning problematic transform from title before maximize:', titleElement.style.transform);
                    titleElement.style.removeProperty('transform');
                }
            }
            
            // Guardar estilos originales incluyendo las dimensiones actuales
            originalStyles = {
                width: el.style.width || el.offsetWidth + 'px',
                height: el.style.height || el.offsetHeight + 'px',
                top: el.style.top,
                left: el.style.left,
                transform: el.style.transform,
                position: el.style.position,
                maxWidth: el.style.maxWidth,
                maxHeight: el.style.maxHeight,
                margin: el.style.margin,
                padding: el.style.padding,
                zIndex: el.style.zIndex
            };

            console.log('Saved original styles:', originalStyles);

            // Maximizar como fullpage
            el.style.width = '100vw';
            el.style.height = '100vh';
            el.style.top = '0';
            el.style.left = '0';
            el.style.right = '0';
            el.style.bottom = '0';
            el.style.transform = 'none';
            el.style.position = 'fixed';
            el.style.zIndex = '13000';
            el.style.maxWidth = 'none';
            el.style.maxHeight = 'none';
            el.style.margin = '0';
            el.style.padding = '0';

            // Asegurar que el contenido del popup se ajuste correctamente
            const popupContent = el.querySelector('.popup-content') || 
                               el.querySelector('f7-page') || 
                               el.querySelector('.page');
            
            if (popupContent) {
                popupContent.style.height = '100vh';
                popupContent.style.overflow = 'auto';
                popupContent.style.display = 'flex';
                popupContent.style.flexDirection = 'column';
                
                // Buscar el page-content y asegurar que tenga flex: 1
                const pageContent = popupContent.querySelector('.page-content');
                if (pageContent) {
                    pageContent.style.flex = '1';
                    pageContent.style.overflow = 'auto';
                }
            }

            // No ocultar el backdrop para que el popup-close siga funcionando
            // const backdrop = document.querySelector('.popup-backdrop');
            // if (backdrop) {
            //     backdrop.style.display = 'none';
            // }

            maximizeBtn.innerHTML = '<i class="f7-icons">arrow_down_right_arrow_up_left</i>';
            maximizeBtn.title = 'Restaurar';
            isMaximized = true;

            // Deshabilitar el resize cuando está maximizado
            el.style.resize = 'none';
            el.classList.add('popup-maximized');

            console.log('Popup maximized as fullpage');
            
            // Disparar evento personalizado
            if (typeof window.dispatchPopupEvent === 'function') {
                window.dispatchPopupEvent('maximize', el);
            }
        } else {
            // Restaurar estilos originales. Vaciar la propiedad y no `removeProperty`: los nombres van
            // en camelCase (`zIndex`, `maxWidth`) y `removeProperty` los ignoraba, así que la ventana
            // se quedaba con el `z-index: 13000` y sin tope de tamaño después de restaurarla (#1027).
            Object.keys(originalStyles).forEach(prop => {
                if (originalStyles[prop] && originalStyles[prop] !== '') {
                    el.style[prop] = originalStyles[prop];
                } else {
                    el.style[prop] = '';
                }
            });

            // Restaurar el contenido del popup
            const popupContent = el.querySelector('.popup-content') || 
                               el.querySelector('f7-page') || 
                               el.querySelector('.page');
            
            if (popupContent) {
                popupContent.style.removeProperty('height');
                popupContent.style.removeProperty('overflow');
                popupContent.style.removeProperty('display');
                popupContent.style.removeProperty('flex-direction');
                
                // Restaurar el page-content
                const pageContent = popupContent.querySelector('.page-content');
                if (pageContent) {
                    pageContent.style.removeProperty('flex');
                    pageContent.style.removeProperty('overflow');
                }
            }

            // Backdrop no modificado, no necesita restauración
            // const backdrop = document.querySelector('.popup-backdrop');
            // if (backdrop) {
            //     backdrop.style.removeProperty('display');
            // }

            maximizeBtn.innerHTML = '<i class="f7-icons">arrow_up_left_arrow_down_right</i>';
            maximizeBtn.title = 'Maximizar';
            isMaximized = false;

            // Rehabilitar el resize
            el.style.resize = 'both';
            el.classList.remove('popup-maximized');

            console.log('Popup restored');
            
            // Corregir problemas de posicionamiento del título después de restaurar
            setTimeout(() => {
                if (el._correctTitlePositioning) {
                    console.log('Applying title positioning correction after restore...');
                    el._correctTitlePositioning();
                } else {
                    // Fallback si no está disponible la función
                    const titleElement = navbar.querySelector('.title') || navbar.querySelector('f7-nav-title') || navbar.querySelector('.nav-title');
                    if (titleElement) {
                        console.log('Fallback: Correcting title positioning after restore...');
                        
                        if (titleElement.style.left && titleElement.style.left !== '' && titleElement.style.left !== 'auto') {
                            titleElement.style.removeProperty('left');
                        }
                        if (titleElement.style.marginLeft && titleElement.style.marginLeft !== '' && titleElement.style.marginLeft !== 'auto') {
                            titleElement.style.removeProperty('margin-left');
                        }
                        if (titleElement.style.transform && titleElement.style.transform.includes('translateX') && !titleElement.style.transform.includes('-50%')) {
                            titleElement.style.removeProperty('transform');
                        }
                    }
                }
            }, 100); // Pequeño delay para asegurar que la restauración haya terminado
            
            // Disparar evento personalizado
            if (typeof window.dispatchPopupEvent === 'function') {
                window.dispatchPopupEvent('restore', el);
            }
        }
    };

    // Helpers dentro de enhancePopup
    const getPopupEl = () => el.closest && el.closest('.popup') ? el.closest('.popup') : el;
    const getApp = () =>
        (window.app || window.f7) ||
        (vnode && vnode.context && vnode.context.$f7) ||
        null;

    const getInstance = (popupEl, app) => {
        if (!popupEl) return null;
        // orden fiable: cache en el DOM -> API get
        return popupEl.f7Modal ||
            (app && app.popup && typeof app.popup.get === 'function' ? app.popup.get(popupEl) : null);
    };


    // Función para cerrar el popup
    const closePopup = (event) => {
        console.log('Close button clicked for popup:', el, 'Event:', event);

        const popupEl = getPopupEl();
        const app = getApp();

        if (!popupEl || !popupEl.parentNode || !document.contains(popupEl)) {
            console.log('Popup no longer exists, skipping close');
            return;
        }

        // Limpieza ligera previa (sin tocar backdrop/body)
        if (popupEl._popupResizeObserver) {
            popupEl._popupResizeObserver.disconnect();
            popupEl._popupResizeObserver = null;
        }
        if (isMaximized) {
            popupEl.classList.remove('popup-maximized');
        }

        // Intento 1: instancia viva
        try {
            const inst = getInstance(popupEl, app);
            if (inst && typeof inst.close === 'function') {
                console.log('Closing via instance.close()');
                inst.close();
                return;
            }
        } catch (e) {
            console.log('Instance close failed:', e);
        }

        // Intento 2: API global con el elemento
        try {
            if (app && app.popup && typeof app.popup.close === 'function') {
                console.log('Closing via app.popup.close(el)');
                app.popup.close(popupEl);
                return;
            }
        } catch (e) {
            console.log('Global app popup.close failed:', e);
        }

        // Intento 3: botón nativo popup-close del propio popup
        try {
            const nativeBtn = popupEl.querySelector('[popup-close], .popup-close');
            if (nativeBtn) {
                console.log('Clicking native [popup-close] fallback');
                nativeBtn.click();
                return;
            }
        } catch (e) {
            console.log('Native button fallback failed:', e);
        }

        // Sin DOM hacks: si estamos aquí, avisamos del error
        if (typeof window.dispatchPopupEvent === 'function') {
            window.dispatchPopupEvent('closeError', popupEl, { error: 'No instance and no API available' });
        }
    };


    // Añadir el evento del botón maximizar con mejor control
    const maximizeHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Verificar si el popup aún existe y está abierto
        if (!el.parentNode || el.style.display === 'none') {
            console.log('Popup no longer exists or is hidden, skipping toggle');
            return;
        }
        
        toggleMaximize();
    };
    
    maximizeBtn.addEventListener('click', maximizeHandler, true);
    maximizeBtn._clickHandler = maximizeHandler; // Guardar referencia para poder removerlo

    // Cerrada maximizada, la ventana se quedaba fija en pantalla y ya no había forma de quitarla: el
    // `transform: none` en línea anula el desplazamiento de salida, y Framework7 espera a que acabe
    // para darla por cerrada (#1027). Al empezar a cerrarse recupera su tamaño y el cierre termina
    // como siempre. Sin `once`: la ventana se abre y se cierra muchas veces con el mismo botón.
    el.addEventListener('popup:close', () => {
        if (isMaximized) toggleMaximize();
    });

    // No añadimos handler para el botón cerrar: dejamos que el atributo 'popup-close' gestione el cierre nativo de F7
    
    // Asegurar que nav-right muestre los botones en línea
    navRight.style.display = 'flex';
    navRight.style.alignItems = 'center';
    navRight.style.gap = '4px';
    
    // Añadir ambos botones al nav-right (primero el de maximizar, luego el de cerrar)
    console.log('About to append maximize and close buttons to nav-right');
    console.log('Nav-right before append:', navRight);
    console.log('Nav-right innerHTML before:', navRight.innerHTML);
    console.log('Nav-right parent before:', navRight.parentElement);
    
    navRight.appendChild(maximizeBtn);
    navRight.appendChild(closeBtn);

    console.log('Maximize and close buttons added to nav-right');
    console.log('Nav-right after append:', navRight);
    console.log('Nav-right innerHTML after:', navRight.innerHTML);
    console.log('Nav-right parent after:', navRight.parentElement);
    console.log('Maximize button parent:', maximizeBtn.parentElement);
    console.log('Close button parent:', closeBtn.parentElement);
    
    // Verificar la estructura final del navbar
    console.log('Final navbar structure:');
    console.log('- Navbar:', navbar);
    console.log('- Navbar innerHTML:', navbar.innerHTML ? navbar.innerHTML.substring(0, 500) : 'No innerHTML');

    // Detectar y corregir problemas de posicionamiento en el título
    const titleElement = navbar.querySelector('.title') || navbar.querySelector('f7-nav-title') || navbar.querySelector('.nav-title');
    if (titleElement) {
        console.log('Found title element:', titleElement);
        console.log('Title computed styles before correction:');
        const titleStyles = window.getComputedStyle(titleElement);
        console.log('- left:', titleStyles.left);
        console.log('- position:', titleStyles.position);
        console.log('- marginLeft:', titleStyles.marginLeft);
        console.log('- transform:', titleStyles.transform);
        
        // Verificar si tiene left incorrectamente aplicado
        if (titleElement.style.left && titleElement.style.left !== '' && titleElement.style.left !== 'auto') {
            console.log('Detected incorrect left positioning on title:', titleElement.style.left);
            console.log('Removing incorrect left positioning...');
            titleElement.style.removeProperty('left');
        }
        
        // También verificar transform que pueda estar causando problemas
        if (titleElement.style.transform && titleElement.style.transform.includes('translateX')) {
            console.log('Detected potentially problematic transform on title:', titleElement.style.transform);
            // Solo removemos si no es el típico centrado de Framework7
            if (!titleElement.style.transform.includes('-50%')) {
                console.log('Removing problematic transform...');
                titleElement.style.removeProperty('transform');
            }
        }
        
        // Verificar margin-left problemático
        if (titleElement.style.marginLeft && titleElement.style.marginLeft !== '' && titleElement.style.marginLeft !== 'auto') {
            console.log('Detected potentially problematic marginLeft on title:', titleElement.style.marginLeft);
            titleElement.style.removeProperty('margin-left');
        }
        
        console.log('Title styles after correction:');
        const titleStylesAfter = window.getComputedStyle(titleElement);
        console.log('- left:', titleStylesAfter.left);
        console.log('- position:', titleStylesAfter.position);
        console.log('- marginLeft:', titleStylesAfter.marginLeft);
        console.log('- transform:', titleStylesAfter.transform);
    } else {
        console.log('No title element found in navbar');
    }

    // También verificar nav-left para detectar solapamientos
    const navLeft = navbar.querySelector('.nav-left') || navbar.querySelector('f7-nav-left') || navbar.querySelector('.left');
    if (navLeft) {
        console.log('Found nav-left element:', navLeft);
        const navLeftStyles = window.getComputedStyle(navLeft);
        console.log('Nav-left computed styles:');
        console.log('- left:', navLeftStyles.left);
        console.log('- position:', navLeftStyles.position);
        console.log('- width:', navLeftStyles.width);
    }

    // Función para monitorear y corregir problemas de posicionamiento del título
    function setupTitlePositionMonitor() {
        const titleElement = navbar.querySelector('.title') || navbar.querySelector('f7-nav-title') || navbar.querySelector('.nav-title');
        if (!titleElement) return;

        // Función para corregir posicionamiento problemático
        const correctTitlePositioning = (element, context = 'monitor') => {
            let corrected = false;
            
            // Verificar si se añadió un left problemático
            if (element.style.left && element.style.left !== '' && element.style.left !== 'auto') {
                console.log(`[${context}] Detected and correcting problematic left on title:`, element.style.left);
                element.style.removeProperty('left');
                corrected = true;
            }
            
            // Verificar marginLeft problemático
            if (element.style.marginLeft && element.style.marginLeft !== '' && element.style.marginLeft !== 'auto') {
                console.log(`[${context}] Detected and correcting problematic marginLeft on title:`, element.style.marginLeft);
                element.style.removeProperty('margin-left');
                corrected = true;
            }
            
            // Verificar transform problemático
            if (element.style.transform && element.style.transform.includes('translateX') && !element.style.transform.includes('-50%')) {
                console.log(`[${context}] Detected and correcting problematic transform on title:`, element.style.transform);
                element.style.removeProperty('transform');
                corrected = true;
            }
            
            if (corrected) {
                console.log(`[${context}] Title positioning corrected`);
            }
        };

        // Observer para detectar cambios en los atributos de estilo
        const titleObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const element = mutation.target;
                    correctTitlePositioning(element, 'observer');
                }
            });
        });

        titleObserver.observe(titleElement, {
            attributes: true,
            attributeFilter: ['style']
        });

        // Guardar referencia para limpiar después
        el._titleObserver = titleObserver;
        
        // También guardar la función de corrección para uso externo
        el._correctTitlePositioning = () => correctTitlePositioning(titleElement, 'manual');
    }

    // Configurar el monitor de posición del título
    setupTitlePositionMonitor();

    // Estilos inline removidos temporalmente para debugging

    // Función para restaurar el centrado solo cuando sea necesario (sin bucles)
    function restorePopupCentering() {
        // Verificar que el popup aún existe y no se está cerrando
        if (!el || !el.parentNode || !document.contains(el) || el.style.display === 'none' || 
            isMaximized || el.classList.contains('popup-maximized') || 
            el.classList.contains('popup-closing')) {
            return;
        }
        
        try {
            const rect = el.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const centerX = windowWidth / 2;
            const centerY = windowHeight / 2;
            
            // Solo recentrar si está muy descentrado (más de 100px) y el popup es visible
            const isVeryOffCenter = Math.abs(rect.left + rect.width / 2 - centerX) > 100 || 
                                  Math.abs(rect.top + rect.height / 2 - centerY) > 100;
            
            if (isVeryOffCenter && rect.width > 0 && rect.height > 0) {
                console.log('Recentering popup that was very off-center');
                el.style.position = 'fixed';
                el.style.top = '50%';
                el.style.left = '50%';
                el.style.transform = 'translate(-50%, -50%)';
                el.style.margin = '0';
            }
        } catch (error) {
            console.log('Error in restorePopupCentering, popup may be closing:', error);
        }
    }

    // Observer simple solo para casos extremos de descentrado
    if (typeof ResizeObserver !== 'undefined') {
        let resizeTimeout;
        let lastSize = { width: el.offsetWidth, height: el.offsetHeight };
        let isClosing = false;
        
        const resizeObserver = new ResizeObserver((entries) => {
            // No hacer nada si el popup se está cerrando o no es válido
            if (isClosing || !el || !el.parentNode || !document.contains(el) || 
                el.style.display === 'none' || el.classList.contains('popup-closing')) {
                return;
            }
            
            try {
                // Solo actuar si realmente cambió el tamaño significativamente
                const entry = entries[0];
                if (!entry || !entry.contentRect) {
                    return;
                }
                
                const newWidth = entry.contentRect.width;
                const newHeight = entry.contentRect.height;
                
                if (Math.abs(newWidth - lastSize.width) > 10 || Math.abs(newHeight - lastSize.height) > 10) {
                    lastSize = { width: newWidth, height: newHeight };
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(() => {
                        if (!isClosing && el && el.parentNode && document.contains(el)) {
                            restorePopupCentering();
                        }
                    }, 300);
                }
            } catch (error) {
                console.log('Error in ResizeObserver callback:', error);
            }
        });
        
        // Solo observar si el elemento es válido
        if (el && el.parentNode && document.contains(el)) {
            resizeObserver.observe(el);
            el._popupResizeObserver = resizeObserver;
        } else {
            console.log('Element not valid for ResizeObserver, disconnecting');
            resizeObserver.disconnect();
            return;
        }
        
        // Detectar cuando el popup empieza a cerrarse
        el.addEventListener('popup:close', () => {
            console.log('Popup starting to close');
            isClosing = true;
            clearTimeout(resizeTimeout);
            // Emitimos nuestro evento personalizado antes de cerrar
            if (typeof window.dispatchPopupEvent === 'function') {
                window.dispatchPopupEvent('beforeClose', el);
            }
            // No desactivamos ni quitamos listeners de los botones para no interferir con el cierre
        }, { once: true });
        
        // Limpiar el observer cuando se cierre el popup
        el.addEventListener('popup:closed', () => {
            console.log('Popup closed, cleaning up observers and timeouts');
            isClosing = true;
            
            // Verificar que el elemento aún existe antes de limpieza
            if (el && el._popupResizeObserver) {
                el._popupResizeObserver.disconnect();
                el._popupResizeObserver = null;
            }
            
            // Limpiar el observer del título
            if (el && el._titleObserver) {
                el._titleObserver.disconnect();
                el._titleObserver = null;
            }
            
            clearTimeout(resizeTimeout);
            
            // Limpiar el backdrop si quedó modificado
            const backdrop = document.querySelector('.popup-backdrop');
            if (backdrop) {
                backdrop.style.removeProperty('display');
            }
            
            // NO remover el atributo data-popup-enhanced para evitar duplicación de botones
            // al reabrir el popup - el botón ya existe y debe mantenerse
            console.log('Keeping data-popup-enhanced attribute to prevent button duplication');

            // Emitimos nuestro evento personalizado de cerrado
            if (typeof window.dispatchPopupEvent === 'function') {
                window.dispatchPopupEvent('closed', el);
            }
            
        }, { once: true });

        // También limpiar si el popup se destruye del DOM
        const cleanupObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.removedNodes.forEach((node) => {
                    if (node === el || (node && node.contains && node.contains(el))) {
                        console.log('Popup removed from DOM, cleaning up');
                        isClosing = true;
                        if (el && el._popupResizeObserver) {
                            el._popupResizeObserver.disconnect();
                            el._popupResizeObserver = null;
                        }
                        clearTimeout(resizeTimeout);
                        cleanupObserver.disconnect();
                    }
                });
            });
        });
        
        cleanupObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Estilos CSS removidos temporalmente para debugging

    console.log('Popup enhancement completed successfully');
    
    // Disparar evento personalizado de enhancement completado
    if (typeof window.dispatchPopupEvent === 'function') {
        window.dispatchPopupEvent('enhanced', el);
    }
}

function checkPermission(el, roles, vnode) {
    let user = getUser();
    if (!user || user == null || (user.roles.indexOf("ADMIN") < 0 && roles.filter(r => user.roles.indexOf(r) > -1).length <= 0)) {
        // el.style.display = "none";
        // el.classList.add("display-none");
        removeElement(el, vnode);
    } 
    // else {
    //     if (tipoCliente && user.clientes && user.clientes.filter(c => c.tipoCliente == tipoCliente).length <= 0) {
    //         el.style.display = "none";
    //         el.classList.add("display-none");
    //     } else {
    //         el.style.display = el.getAttribute("data-initial-display");
    //         el.classList.remove("display-none");
    //     }
    // }
}
function checkNoPermission(el, roles, vnode) {
    let user = getUser();
    if (!user || user == null || roles.filter(r => user.roles.indexOf(r) > -1).length) {
        // el.style.display = "none";
        // el.classList.add("display-none");
        removeElement(el, vnode);
    }
}

function removeElement(el, vnode) {
    // replace HTMLElement with comment node
    const comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
      value: () => undefined,
    });
    vnode.elm = comment;
    vnode.text = ' ';
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;
  
    if (vnode.componentInstance) {
      vnode.componentInstance.$el = comment;
    }
  
    if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
  }

function getUser() {
    var user = localStorage.getItem("user");
    if (typeof user != "undefined" && user) {
        var userObj = JSON.parse(user);
        return userObj;
    }
    return null;
}

// Función global para mejorar popups manualmente
window.enhanceAllPopups = function() {
    console.log('Manual popup enhancement triggered');
    const allPopups = [
        ...document.querySelectorAll('.popup'),
        ...document.querySelectorAll('f7-popup'),
        ...document.querySelectorAll('[data-name="popup"]')
    ];
    
    console.log('Found popups to enhance:', allPopups.length);
    
    allPopups.forEach(popup => {
        const validation = isValidPopupElement(popup);
        if (validation.valid) {
            console.log('Manually enhancing popup:', popup);
            enhancePopup(popup);
        } else {
            console.log('Skipping popup:', validation.reason, popup);
        }
    });
};

// Función de debug mejorada para diagnosticar problemas con popups
window.debugPopups = function() {
    console.log('=== POPUP DEBUG INFORMATION ===');
    
    // Buscar todos los popups
    const allPopups = [
        ...document.querySelectorAll('.popup'),
        ...document.querySelectorAll('f7-popup'),
        ...document.querySelectorAll('[data-name="popup"]')
    ];
    
    console.log('Total popups found:', allPopups.length);
    
    allPopups.forEach((popup, index) => {
        console.log(`--- Popup ${index + 1} ---`);
        console.log('Element:', popup);
        
        // Validación completa
        const validation = isValidPopupElement(popup);
        console.log('Valid:', validation.valid, '- Reason:', validation.reason);
        
        console.log('Enhanced:', !!(popup.dataset && popup.dataset.popupEnhanced));
        console.log('Visible:', popup.style.display !== 'none' && !popup.hidden);
        console.log('Framework7 instance:', popup.f7Popup);
        console.log('Classes:', popup.classList ? Array.from(popup.classList) : 'No classList');
        
        // Buscar navbar y botones
        try {
            const navbar = popup.querySelector('.navbar, f7-navbar');
            const navRight = navbar ? navbar.querySelector('.nav-right, f7-nav-right, .right') : null;
            const customButtons = navRight ? navRight.querySelectorAll('.popup-maximize-btn, .popup-close-btn') : [];
            
            console.log('Has navbar:', !!navbar);
            console.log('Has nav-right:', !!navRight);
            console.log('Custom buttons:', customButtons.length);
            
            if (customButtons.length > 0) {
                customButtons.forEach((btn, btnIndex) => {
                    console.log(`  Button ${btnIndex + 1}:`, btn.className, 'Text:', btn.textContent);
                });
            }
        } catch (error) {
            console.log('Error analyzing popup structure:', error);
        }
        
        console.log('---');
    });
    
    // Verificar instancia de Framework7
    const app = window.app || window.f7;
    console.log('Framework7 app instance:', app);
    console.log('Framework7 popup API:', app && app.popup);
    
    console.log('=== END POPUP DEBUG ===');
};

// Añadir funciones al objeto window para fácil acceso
window.popupDebug = {
    enhance: window.enhanceAllPopups,
    debug: window.debugPopups,
    closeAll: function() {
        const popups = document.querySelectorAll('.popup:not(.popup-closing)');
        popups.forEach(popup => {
            const app = window.app || window.f7;
            if (app && app.popup) {
                app.popup.close(popup);
            }
        });
    }
};

// Sistema de eventos para detectar popups dinámicamente
document.addEventListener('DOMContentLoaded', () => {
    console.log('Setting up popup enhancement event listeners');
    
    // Observer global para detectar nuevos popups sin interferir con Framework7
    const globalPopupObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Verificar que el nodo sea válido y esté en el DOM
                    if (!node || !node.classList || !document.contains(node)) {
                        return;
                    }
                    
                    // Verificar si es un popup o contiene popups
                    if (node.classList.contains('popup') || node.tagName === 'F7-POPUP') {
                        if (!node.dataset || !node.dataset.popupEnhanced) {
                            // Verificar que no se esté cerrando
                            if (!node.classList.contains('popup-closing') && 
                                !node.classList.contains('popup-close') &&
                                node.parentNode) {
                                
                                console.log('New popup detected, scheduling enhancement:', node);
                                
                                // Usar múltiples delays para asegurar que Framework7 termine
                                setTimeout(() => {
                                    // Verificación final antes de enhancer
                                    if (node && 
                                        node.parentNode && 
                                        document.contains(node) &&
                                        !node.classList.contains('popup-closing') && 
                                        (!node.dataset || !node.dataset.popupEnhanced)) {
                                        
                                        console.log('Enhancing detected popup:', node);
                                        enhancePopup(node);
                                    } else {
                                        console.log('Popup no longer valid for enhancement:', node);
                                    }
                                }, 200); // Aumentar delay para mejor compatibilidad
                            }
                        }
                    }
                    
                    // Buscar popups dentro del nodo añadido con validaciones
                    try {
                        const innerPopups = [
                            ...node.querySelectorAll('.popup:not(.popup-closing):not(.popup-close)'),
                            ...node.querySelectorAll('f7-popup:not(.popup-closing):not(.popup-close)')
                        ];
                        
                        innerPopups.forEach(popup => {
                            if (popup && 
                                popup.parentNode && 
                                document.contains(popup) &&
                                (!popup.dataset || !popup.dataset.popupEnhanced)) {
                                
                                console.log('New inner popup detected, scheduling enhancement:', popup);
                                
                                setTimeout(() => {
                                    if (popup && 
                                        popup.parentNode && 
                                        document.contains(popup) &&
                                        !popup.classList.contains('popup-closing') && 
                                        (!popup.dataset || !popup.dataset.popupEnhanced)) {
                                        
                                        console.log('Enhancing inner popup:', popup);
                                        enhancePopup(popup);
                                    }
                                }, 200);
                            }
                        });
                    } catch (error) {
                        console.error('Error processing inner popups:', error);
                    }
                }
            });
        });
    });
    
    // Observar cambios en todo el documento
    globalPopupObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Escuchar eventos específicos de Framework7 para popups
    document.addEventListener('popup:opened', (e) => {
        console.log('Framework7 popup opened event detected:', e.detail);
        
        // Validar que el evento y el popup sean válidos
        if (!e.detail || !e.detail.el) {
            console.log('Invalid popup opened event, skipping');
            return;
        }
        
        const popup = e.detail.el;
        
        // Validar que el popup sea un elemento válido
        if (!popup || !popup.parentNode || !document.contains(popup)) {
            console.log('Popup from opened event is not valid, skipping');
            return;
        }
        
        if (!popup.dataset || !popup.dataset.popupEnhanced) {
            console.log('Enhancing popup from opened event:', popup);
            
            // Usar un delay más corto ya que Framework7 ya disparó el evento
            setTimeout(() => {
                if (popup && 
                    popup.parentNode && 
                    document.contains(popup) &&
                    (!popup.dataset || !popup.dataset.popupEnhanced)) {
                    
                    enhancePopup(popup);
                }
            }, 50);
        }
    });
    
    // Ejecutar una vez al cargar para popups existentes
    setTimeout(() => {
        console.log('Initial popup enhancement scan');
        window.enhanceAllPopups();
    }, 1000);
});

// Eventos personalizados para el sistema de popups
window.dispatchPopupEvent = function(eventType, popup, data = {}) {
    // Validar que el popup existe y es válido antes de enviar evento
    if (!popup || !popup.parentNode || !document.contains(popup)) {
        console.log(`Skipping popup event '${eventType}' - popup no longer valid`);
        return;
    }
    
    try {
        const event = new CustomEvent(`popup:${eventType}`, {
            detail: { popup, ...data },
            bubbles: true
        });
        document.dispatchEvent(event);
    } catch (error) {
        console.error(`Error dispatching popup event '${eventType}':`, error);
    }
};

// Escuchar nuestros eventos personalizados
document.addEventListener('popup:maximize', (e) => {
    if (e.detail && e.detail.popup) {
        console.log('Popup maximized:', e.detail.popup);
    }
});

document.addEventListener('popup:restore', (e) => {
    if (e.detail && e.detail.popup) {
        console.log('Popup restored:', e.detail.popup);
    }
});

document.addEventListener('popup:enhanced', (e) => {
    if (e.detail && e.detail.popup) {
        console.log('Popup enhanced:', e.detail.popup);
    }
});

document.addEventListener('popup:beforeClose', (e) => {
    if (e.detail && e.detail.popup) {
        console.log('Popup about to close:', e.detail.popup);
    }
});

document.addEventListener('popup:closed', (e) => {
    if (e.detail && e.detail.popup) {
        console.log('Popup closed by custom button:', e.detail.popup);
    }
});

document.addEventListener('popup:closeError', (e) => {
    if (e.detail && e.detail.popup) {
        console.error('Error closing popup:', e.detail.popup, e.detail.error);
    }
});

// Inicializar gestor de actualizaciones
UpdateManager.init();

// #663 · La cancelación de una petición de otra sesión recorre la cadena sin que la pantalla la
// atienda, a propósito; aquí se recoge para que no salga como rechazo sin tratar.
instalarRecogidaDeCancelaciones();

// Init App
new Vue({
    el: '#app',
    render: (h) => h(App),
    i18n,
    vuetify,
    // Register App Component
    components: {
        app: App
    },
});